import React, { useState } from "react";
import { targetData } from "../assets/data";
import {MdOutlineAttachMoney} from "react-icons/md"

function TotalvalueSingle({ targetData,indexVal,clickHandle,isOpen}) {
  const [openModalValuestate,setopenModalValueState] = useState("");
  const { target, growth, margin, dist, budget, budgetChange } = targetData;
  const colorValue = {
    negative: "#f59994",
    positive: "#12d965",
  };

  if(isOpen === indexVal){
    
  }
  function openModalValue(args){
    console.log(openModalValuestate,"open");
    console.log(indexVal,"key");
    if(args === openModalValuestate){
      setopenModalValueState("");
      console.log("true");
    }
    else{
      setopenModalValueState(indexVal);
      console.log("false");
    }
  }
  return (
    <div
      className={
        target === "+" ? "singleDetails-div opacitySingle" : "singleDetails-div"
      }
    >
      <div className="totalValueSingle singleDetails">
        <div class="totalValueSingleTarget" onClick={()=>clickHandle(indexVal)}> 
        {/* onClick={()=>openModalValue(indexVal)} */}
          <p style={{ color: colorValue.lightBlue }}>{target}</p>
            <div className={openModalValuestate === indexVal && openModalValuestate !=="" ?"modal-container-upper":"modal-container-upper modalhideShow"}>
            <div className="modal-container">
  <div className="modal-div"> 
    <p>Set #Product Name,</p>
    <p>Sales Channel #</p>
    <div className="modal-input-div">
      <p>Target</p>
      <div className="div-input"><input type="text" value="12.34"/><div class="modal-icon-div">฿</div></div>
    </div>
    <div className="modal-input-div">
      <p>Margin</p>
      <div className="div-input"><input type="text" value="13.25"/><div class="modal-icon-div">%</div></div>
    </div>
    
    <div className="modal-input-div">
      <p>Budget%</p>
      <div className="budget div-input">
        <div className="budget-div1">
          <input type="text" value="42.34"/>
          <div className="modal-icon-div">฿</div>    
          </div>
        <div className="budget-div2">
          <input type="text" value="32"/>
        <div className="modal-icon-div">%</div>
        </div>
        </div>
    </div>
    <div className="button-modal modal-input-div">
      <button>Cancel</button>
      <button>Confirm</button>
    </div>
  </div>
</div>
            </div>
        </div>
        <div>
          <p
            style={
              growth >= 0
                ? { color: colorValue.positive }
                : { color: colorValue.negative }
            }
          >
            {growth > 0 ? "+" : null}
            {growth}%
          </p>
        </div>
        <div>
          <p style={{ color: colorValue.white }}>{margin}%</p>
        </div>
        <div>
          <p style={{ color: colorValue.white }}>{dist}</p>
        </div>
        <div className="singleDetailsBudget">
          <p style={{ color: colorValue.white }}>{budget} </p>
          <span style={{ color: colorValue.white }} className="budjectPercent">
            {String(budgetChange).length>2?String(budgetChange).slice(0,-1):String(budgetChange)}%
          </span>
        </div>
      </div>
    </div>
  );
}

export default TotalvalueSingle;
